import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Container } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import NavLogo from '../svg/RouletteWheel3color';
import { localePath, localizedPageFromPath } from '../utils/languages';

const languages = [
  { code: 'de', path: '/de/', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', path: '/', name: 'English', flag: '🇺🇸' },
  { code: 'es', path: '/es/', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', path: '/pt/', name: 'Português', flag: '🇵🇹' },
  { code: 'tr', path: '/tr/', name: 'Türkçe', flag: '🇹🇷' },
];

const getLanguagePath = (lang, currentPath) => {
  const page = localizedPageFromPath(currentPath);
  if (page) {
    return localePath(lang.path, page);
  }
  return lang.path;
};

const HeaderNav = ({ path, translate }) => {
  const homeLink = translate.language === 'en' ? '/' : `/${translate.language}/`;
  const currentLang = languages.find(lang => lang.code === translate.language) || languages[1];

  return (
    <header className="navBar">
      <Container>
        <div className="navLogo">
          <GatsbyLink to={homeLink} aria-label="TV Roulette">
            <NavLogo />
            <h3>
              <span>TV Roulette</span>
              <small>{translate.nav.tagline}</small>
            </h3>
          </GatsbyLink>
        </div>

        <nav className="navItemsGroup">
          <span className="navItem navLinkAnchor">
            <GatsbyLink to={localePath(path, 'how-it-works')}>{translate.nav.howItWorks}</GatsbyLink>
          </span>
          <span className="navItem navLinkAnchor">
            <GatsbyLink to="/guides/">{translate.nav.guides}</GatsbyLink>
          </span>
          <span className="navItem navLinkAnchor">
            <GatsbyLink to="/blog/">{translate.nav.blog}</GatsbyLink>
          </span>

          <div className="langDropdown">
            <Dropdown>
              <Dropdown.Toggle id="language-select">
                <span className="lang-flag">{currentLang.flag}</span>
                <span className="lang-code">{currentLang.code.toUpperCase()}</span>
                <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {languages.map(lang => (
                  <Dropdown.Item key={lang.code} as="div">
                    <GatsbyLink to={getLanguagePath(lang, path)}>
                      <span className="lang-flag">{lang.flag}</span>
                      <span className="lang-name">{lang.name}</span>
                      {lang.code === translate.language && <span className="lang-check">✓</span>}
                    </GatsbyLink>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </nav>
      </Container>
    </header>
  );
};

export default HeaderNav;
